export interface MerchantSupportSession {
  sessionId: string;
  merchantId: string;
  merchantName: string;
  expiresAt: string;
}

const STORAGE_KEY = "splitkart_merchant_support_session";

export function getMerchantSupportSession(): MerchantSupportSession | null {
  try {
    const rawValue = sessionStorage.getItem(STORAGE_KEY);
    if (!rawValue) {
      return null;
    }

    const session = JSON.parse(rawValue) as MerchantSupportSession;
    if (
      !session.sessionId ||
      !session.merchantId ||
      !session.expiresAt ||
      new Date(session.expiresAt).getTime() <= Date.now()
    ) {
      clearMerchantSupportSession();
      return null;
    }

    return session;
  } catch {
    clearMerchantSupportSession();
    return null;
  }
}

export function setMerchantSupportSession(session: MerchantSupportSession): void {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
}

export function clearMerchantSupportSession(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
